const theme = {
	colors: {
		white: '#FFFFFF',
		mineShaft: '#333333',
		tundora: '#444444',
		doveGray: '#666666',
		dustyGray: '#999999',
		gallery: '#ECECEC',
		emperor: '#4f4f4f',
		gray: '#888888',
		wildSand: '#F6F6F6',
		alto: '#d1d1d1',
		shadowDarkerRegular: '#5555554D',
		neutralWhite: '#FFFFFF',
		textDarkestMedium: '#444444',
	},
	fonts: {
		sourceSansPro: 'Source Sans Pro, sans-serif',
	},
	media: {
		xs: '360px',
		sm: '576px',
		md: '768px',
		lg: '1120px',
		xl: '1248px',
		xxl: '1440px',
	},
	space: {
		'90': '5.625rem',
		'82': '5.125rem',
		'72': '4.5rem',
		'64': '4rem',
		'56': '3.5rem',
		'48': '3rem',
		'40': '2.5rem',
		'32': '2rem',
		'24': '1.5rem',
		'16': '1rem',
		'12': '0.75rem',
		'8': '0.5rem',
		'4': '0.25rem',
	},
	borderWidths: {
		'1': '1px',
		'2': '2px',
		'3': '3px',
		'8': '8px',
	},
};

export default theme;
